// @mui
import PropTypes from "prop-types";
import { alpha, styled } from "@mui/material/styles";
import InfoIcon from "@mui/icons-material/Info";
import {
  Box,
  Card,
  CardActionArea,
  Checkbox,
  Grid,
  Paper,
  Typography,
  Tooltip
} from "@mui/material";
import {
  setCurrentTab,
  setProfileOptions,
  setActivityOptions,
  setDisableFrom,
  setEntityTypeOptions,
} from "../Containers/OnBoarding/slice";
// utils
// components
import Iconify from "./Iconify";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { EntityType } from "../common/enum";

AppWidgetSummary.propTypes = {
  color: PropTypes.string,
  icon: PropTypes.string,
  title: PropTypes.string.isRequired,
  total: PropTypes.number,
  sx: PropTypes.object,
};

export default function AppWidgetSummary({
  setBlock,
  block,
  title,
  total,
  type,
  setDetails,
  details,
  icon,
  color = "primary",
  sx,
  value,
  isChecked = false,
  isCreateDonation = false,
  clickHandler,
  subtitle,
  subtitleFont=16,
  width,
  isCalendar,
  ...other
}) {
  const label = { inputProps: { "aria-label": "Checkbox demo" } };
  const {
    onBoarding: { currentTab, profileOptionsValue },
  } = useSelector((state) => state);
  const dispatch = useDispatch();
  const [checked, setChecked] = React.useState(isChecked);
  const onClickFun = async () => {
    switch (type) {
      case "profile":
        dispatch(setProfileOptions(value));
        dispatch(setDisableFrom(2));
        break;
      case "activity":
        dispatch(setActivityOptions(value));
        dispatch(setDisableFrom(3));

        break;
      case "entityType":
        dispatch(setEntityTypeOptions(value));
        dispatch(setDisableFrom(4));
        break;
    }
    if (!isChecked) {
      // setChecked(true);
    }
    setTimeout(() => {
      dispatch(setCurrentTab(Number(block) + 1));
      // setBlock(block + 1)
      //details.push(title)
       //setDetails(details);
    }, 500);
  };

  return (
    <Card
      sx={{
        m: value === EntityType.specialDistributor ? 1 : 1,
        my: value === EntityType.specialDistributor ? "" : "",
        mr: value === EntityType.specialDistributor ? "" : "",
        ml: value === EntityType.specialDistributor ? "" : "",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        ...sx,
        "& > :not(style)": {
          // m: 1,
          // margin: "auto",
          border: isChecked ? `3px solid #37B34A` : null,
          width: value === EntityType.specialDistributor ? 205 : 205,
          height: value === EntityType.specialDistributor ? 205 : 205,
        },
      }}
    >
       
      {/* <CardActionArea> */}
      <CardActionArea
        sx={{
          borderRadius: 1,
          p: 3,
          // m: isChecked && 1,
          display: !isChecked && "flex",
          flexDirection: !isChecked && "column",
          justifyContent: !isChecked && "center",
          alignItems: !isChecked && isCreateDonation ? "flex-start" : "center",
          position: "relative",
        }}
        onClick={() => (clickHandler ? clickHandler() : onClickFun())}
      >
        {value === EntityType.specialDistributor && (
          <Box sx={{position: "absolute" , top: 4 , left: 5}}>
          <Tooltip title={subtitle}>
            <InfoIcon
              sx={{
                backgroundColor: `#37B34A`,
                color: "white",
                width: 32,
                height: 32,
                padding: 0.5,
                mr: 1,
                borderRadius: "10px",
              }}
            />
          </Tooltip>
          </Box>
          
        )}
        {/* <Grid sx={{display:'flex',  justifyItems:'center',justifyContent:'center',}} container height={"100%"} justifyContent={"center"}> */}
        {/* <Grid  item xs={12}> */}
        {isChecked ? (
          <img
            src={"/static/selected.png"}
            alt="Opção selecionada"
            style={{ width: "40px", position: "absolute", right: -2, top: -4 }}
          />
        ) : null}
        {/* </Grid> */}
        {/* <Grid sx={{display:'flex', flexDirection:'column', justifyContent:'center',alignItems:'center'}} item xs={12} display> */}
        <Box
          sx={{
            mb: 2,
            display: "flex",
            justifyContent: "center",
            alignItems:
              value === EntityType.specialDistributor ? "center" : "center",
          }}
        >
          
          <img src={icon} alt={`Icon para ${title}`} style={{ width: "40px",height:'40px',...isCalendar}} />
          {/* {value === EntityType.specialDistributor && (
            <>
            <Typography
              sx={{ wordWrap: "break-word" }}
              fontWeight={"700"}
              fontSize={16}
            >
              {title}
            </Typography>
            {subtitle ? (
              <Typography fontSize={subtitleFont}>{subtitle}</Typography>
            ) : null}
          </>
          )} */}
        </Box>
        {/* </Grid> */}
        {/* <Grid  item xs={12}> */}
       
          <>
            <Typography
              sx={{ wordWrap: "break-word" }}
              fontWeight={"700"}
              fontSize={16}
              textAlign={"center"}
            >
              {title}
            </Typography>
            {/* {subtitle ? (
              <Typography fontSize={subtitleFont}>{subtitle}</Typography>
            ) : null} */}
          </>
        
        {/* </Grid> */}
        {/* </Grid> */}
        {/* </Paper> */}
      </CardActionArea>
    </Card>
  );
}
